import { NetworkImage } from '@/components/common/networkImage'
import { ProtocolImage } from '@/components/common/protocolImage'
import { CategoryBadge } from '@/components/shared/categoryBadge'
import type { Vault } from '@/types/vault'
import { cn } from '@/utils/cn'
import { getNetworkName } from '@/utils/network/getNetworkName'
import type { ComponentProps } from 'react'

interface Props {
  vault: Vault
}

export const OpportunityHeader = ({ vault, className, ...props }: Props & ComponentProps<'header'>) => {
  const { name, protocol, network, tags } = vault

  return (
    <header
      className={cn('flex max-w-full flex-wrap items-center gap-2 overflow-hidden md:gap-4', className)}
      {...props}
    >
      <div className="flex max-w-full items-center gap-2 overflow-hidden md:gap-4">
        <ProtocolImage protocol={protocol} className={cn('size-6 p-0.5', 'md:size-8', 'lg:size-10')} />
        <h1 className="max-w-full truncate font-medium text-2xl text-heading-foreground lg:text-[28px]" title={name}>
          {name}
        </h1>
      </div>
      <div className="flex max-w-full items-center gap-2 overflow-hidden md:gap-4">
        <div className="flex items-center gap-2 rounded-full border bg-page px-2 py-1">
          <NetworkImage network={network.name} />
          <span className="text-sm capitalize">{getNetworkName(network.name)}</span>
        </div>
        {tags.length > 0 && (
          <div className="flex items-center gap-2">
            {tags.map((tag) => (
              <CategoryBadge key={tag} category={tag} size="md" />
            ))}
          </div>
        )}
      </div>
    </header>
  )
}
